import { FormControl } from '@angular/forms';

export enum PredefinedDateRange {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_14_DAYS = 'LAST_14_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_MONTH = 'LAST_MONTH',
  LAST_YEAR = 'LAST_YEAR',
  THIS_MONTH = 'THIS_MONTH',
  THIS_YEAR = 'THIS_YEAR',
}

export class Address {
  public country: string;
  public street: string;
  public houseNumber: string;
  public apartmentNumber: string;
  public postalCode: string;
  public city: string;

  constructor(country: string) {
    this.country = country;
  }
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortEvent = {
  name: string,
  direction: SortDirection
} | null;

export enum Background {
  Danger = 'bg-danger',
  Warning = 'bg-warning',
  Success = 'bg-success',
}

export interface IPageablePayload {
  pageSize: number;
  page: number;
}

export interface ISortablePayload {
  sortField: string;
  sortOrder: SortDirection;
}

export interface IRangePayload {
  startDate: string;
  endDate: string;
}

export interface IIdName {
  id: string;
  name: string;
}

export type ControlsStruct<BaseType> = {
  [P in keyof BaseType]: FormControl<BaseType[P]>;
};

export enum TrafficType {
  PRODUCT = 'PRODUCT',
  BANNER = 'BANNER',
}
export const isBanner =
  (trafficType: TrafficType): trafficType is TrafficType.BANNER =>
    trafficType === TrafficType.BANNER;
export const isProduct =
  (trafficType: TrafficType): trafficType is TrafficType.PRODUCT =>
    trafficType === TrafficType.PRODUCT;
